<template>
    <div v-show="visible">
        <el-dialog title="新增" :visible.sync="visible" :close-on-click-modal="false" :before-close="dialogClose" width="65%">    
            <el-form ref="form" :model="form" :rules="rules" label-width="85px">
                <div style="font-size:14px;margin-bottom:10px;font-weight:bold;">基本信息：</div>    
                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="name" label="姓名">
                            <el-input v-model="form.name" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="deptId" label="所属机构">
                            <el-cascader
                                :options="depts"
                                v-model="form.deptId"
                                :props="props"
                                collapse-tags
                                clearable
                                @change="onDeptChange"></el-cascader>
                        </el-form-item>
                    </el-col>
                    
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="cardNo" label="卡号">
                            <el-select
                                v-model="form.cardNo"
                                clearable
                                filterable
                                remote
                                reserve-keyword
                                :remote-method="onCardNoRemote"
                                :loading="cardNoLoading"
                                popper-class="student-cardno-dropdown-add"
                                placeholder="请选择卡号"
                                style="width:100%;"
                                @visible-change="onCardNoVisibleChange">
                                <el-option
                                    v-for="item in cardNoOptions"
                                    :key="item.cardNo"
                                    :label="item.cardNo"
                                    :value="item.cardNo">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>

                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="sex" label="性别">
                            <el-select v-model="form.sex" clearable placeholder="请选择">
                                <el-option v-for="item in sexs" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="identityCard" label="身份证">
                            <el-input v-model="form.identityCard" :readonly="true" maxlength="50"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="studentType" label="学生类型">
                            <el-select v-model="form.studentType" clearable placeholder="请选择">
                                <el-option v-for="item in studentTypes" :key="item.value" :label="item.label" :value="item.value"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="classNo" label="班内学号">
                            <el-input v-model="form.classNo" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="roomNumber" label="宿舍房间号">
                            <el-input v-model="form.roomNumber" maxlength="200" :disabled="form.studentType != 1"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                         <el-form-item prop="studentId" label="学籍辅号">
                            <el-input v-model="form.studentId" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="expertise" label="有何专长">
                            <el-input v-model="form.expertise" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="hobby" label="爱好">
                             <el-input v-model="form.hobby" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>

                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="graduationDate" label="毕业年月">
                            <el-input v-model="form.graduationDate" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="orderNum" label="排序号">
                            <el-input v-model="form.orderNum" maxlength="100" type="number"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8">
                    </el-col>
                    <el-col :lg="8" :xl="8">
                        <div style="height: 1px;"></div>
                    </el-col>
                </el-row>

                <div style="font-size:14px;margin-bottom:10px;font-weight:bold;">通讯信息：</div>
                <el-row :gutter="15">
                    <el-col :lg="8" :xl="8">
                        <el-form-item prop="mobile1" label="移动电话">
                             <el-input v-model="form.mobile1" maxlength="100"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :lg="8" :xl="8"><div style="height: 1px;"></div></el-col>
                    <el-col :lg="8" :xl="8"><div style="height: 1px;"></div></el-col>
                </el-row>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="visible=false">取消</el-button>
                <el-button type="primary" :loading="loading" @click="save()">确定</el-button>
            </span>    
        </el-dialog>
    </div>
</template>
       
<script>
    import http from '../../../../common/http';

    export default {
        data(){
            return{
                loading:false,
                visible: false,
                props: { multiple: true,  checkStrictly: true },
                depts:[],
                cardNoOptions:[],
                cardNoLoading:false,
                cardNoKeyword:"",
                cardNoPage:1,
                cardNoPageSize:30,
                cardNoTotal:0,
                cardNoSchoolId:"",
                sexs:[{
                    value: 1,
                    label: '男'
                }, {
                    value: 2,
                    label: '女'
                }],
                studentTypes:[{
                    value: 1,
                    label: '寄宿生'
                }, {
                    value: 2,
                    label: '走读生'
                }, {
                    value: 3,
                    label: '寄午生'
                }, {
                    value: 4,
                    label: '艺考生'
                }, {
                    value: 5,
                    label: '休假生'
                }, {
                    value: 0,
                    label: '其他'
                }],
                form:{
                    studentId:"",
                    name:"",
                    cardNo:"",
                    personType:1,
                    deptId:"",
                    sex:"",
                    identityCard:"",
                    classNo:"",
                    studentType:"",
                    roomNumber:"",
                    postDescrible:"",
                    office:"",
                    expertise:"",
                    hobby:"",
                    graduationDate:"",
                    orderNum:"1",
                    mobile1:"",
                },
                rules: {
                    name: [
                        { required: true, message: '请输入姓名', trigger: 'blur' }
                    ],
                    deptId: [
                        {type: 'array', required: true, message: '请选择机构', trigger: 'blur' }
                    ],
                    mobile1:[
                        { validator: this.checkPhone, trigger: 'blur' }
                    ],
                }
            }
        },
        created:function () {
            this.getDeptCascader();
        },
        methods:{
            init(){
                this.visible=true;
                this.loading=false;
                if (this.$refs['form'] != undefined) {
                    this.$refs['form'].resetFields();
                }
                this.form.personType = 1;
                this.cardNoOptions = [];
                this.cardNoLoading = false;
                this.cardNoKeyword = "";
                this.cardNoPage = 1;
                this.cardNoTotal = 0;
                this.cardNoSchoolId = "";
            },
            dialogClose(done){
                done();
                this.$reload;
            },
            async checkPhone(rule,value,callback){
                let phoneReg = /^1[2|3|4|5|6|7|8|9][0-9]{9}$/
                if(this.$util.isEmpty(value)){
                    callback();
                    return;
                }
                if (phoneReg.test(value)) {
		          callback()
		        } else {
		          callback(new Error('移动电话格式不正确'))
		        }
            },
            filterDeptOptions(nodes){
                if(!Array.isArray(nodes)){
                    return [];
                }
                let res = [];
                for(let i=0;i<nodes.length;i++){
                    let n = nodes[i];
                    let children = this.filterDeptOptions(n.children);
                    let match = (n.parentId === 0) || (this.$util.isNotEmpty(n.label) && (n.label.indexOf('年级') > -1 || n.label.indexOf('不在班学生组') > -1));
                    if(match || (children && children.length > 0)){
                        res.push(Object.assign({}, n, { children }));
                    }
                }
                return res;
            },
            getDeptCascader(){
                let url  = this.getDeptCascaderUrl;
                let data = {};
                this.apiPost(url,data).then((res) => {
                    if(res.status == 200){
                      this.depts = this.filterDeptOptions(res.data.selects); 
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                });
            },
            getSchoolIdFromDeptVal(val){
                if(!Array.isArray(val) || val.length === 0){
                    return "";
                }
                // props.multiple=true 时，val 形如 [[school,grade,class]]；否则形如 [school,grade,class]
                let path = Array.isArray(val[0]) ? val[0] : val;
                return path && path.length > 0 ? path[0] : "";
            },
            onDeptChange(val){
                let schoolId = this.getSchoolIdFromDeptVal(val);
                if(this.$util.isEmpty(schoolId)){
                    this.cardNoOptions = [];
                    this.form.cardNo = "";
                    this.cardNoSchoolId = "";
                    this.cardNoPage = 1;
                    this.cardNoTotal = 0;
                    return;
                }
                this.cardNoSchoolId = schoolId;
                this.resetCardNoQuery();
                this.queryCardNoList();
            },
            resetCardNoQuery(){
                this.cardNoKeyword = "";
                this.cardNoPage = 1;
                this.cardNoTotal = 0;
                this.cardNoOptions = [];
            },
            onCardNoRemote(query){
                this.cardNoKeyword = query || "";
                this.cardNoPage = 1;
                this.cardNoOptions = [];
                this.queryCardNoList();
            },
            onCardNoVisibleChange(visible){
                if(!visible){
                    return;
                }
                // 首次展开：若还没加载过则拉取第一页
                if(this.cardNoOptions.length === 0){
                    this.cardNoPage = 1;
                    this.queryCardNoList();
                }
                this.$nextTick(() => {
                    this.bindCardNoDropdownScroll();
                });
            },
            bindCardNoDropdownScroll(){
                // 下拉渲染在 body，使用 popper-class 定位
                const wrap = document.querySelector('.student-cardno-dropdown-add .el-select-dropdown__wrap');
                if(!wrap || wrap.__cardNoScrollBound){
                    return;
                }
                wrap.__cardNoScrollBound = true;
                wrap.addEventListener('scroll', () => {
                    if(this.cardNoLoading){
                        return;
                    }
                    if(this.cardNoTotal && this.cardNoOptions.length >= this.cardNoTotal){
                        return;
                    }
                    const reachBottom = wrap.scrollHeight - wrap.scrollTop - wrap.clientHeight <= 5;
                    if(reachBottom){
                        this.cardNoPage = this.cardNoPage + 1;
                        this.queryCardNoList(true);
                    }
                });
            },
            queryCardNoList(isAppend){
                if(this.$util.isEmpty(this.cardNoSchoolId)){
                    return;
                }
                let url = this.cardManageUrl;
                let data = {
                    isPage: 1,
                    page: this.cardNoPage,
                    limit: this.cardNoPageSize,
                    deptId: this.cardNoSchoolId,
                    cardNo: this.cardNoKeyword,
                    studentName: "",
                    useFlag: 0
                };
                this.cardNoLoading = true;
                this.apiPost(url, data).then((res) => {
                    this.cardNoLoading = false;
                    if(res.status == 200){
                        let list = res.data.list || res.data.data || [];
                        this.cardNoTotal = res.data.total || 0;
                        // 仅展示启用卡号；如存在 useFlag，优先展示未使用
                        let enabled = list.filter(x => (x && (x.status == null || x.status == 1)));
                        let unused = enabled.filter(x => (x.useFlag == null || x.useFlag == 0));
                        let next = unused.length > 0 ? unused : enabled;
                        if(isAppend){
                            let map = {};
                            let merged = this.cardNoOptions.concat(next);
                            this.cardNoOptions = merged.filter(x => {
                                let key = x && x.cardNo ? x.cardNo : "";
                                if(this.$util.isEmpty(key)){
                                    return false;
                                }
                                if(map[key]){
                                    return false;
                                }
                                map[key] = true;
                                return true;
                            });
                        }else{
                            this.cardNoOptions = next;
                        }
                    }else{
                        this.$commonFn.showTip(res.message,3);
                    }
                },(err)=>{
                    console.log(err);
                    this.cardNoLoading = false;
                });
            },
            filterCascader(data){
                if(this.$util.isEmpty(data)){
                    return ''
                }
                if(data.length == 0){
                    return ''
                }
                let strArr = []
                for(let i=0;i<data.length;i++){
                    strArr.push(data[i][data[i].length-1])
                }
                return strArr.join(',')
            },
            save(){
                 this.$refs['form'].validate((valid) => {
                    if(!valid){
                        return;
                    }
                    let deptId = this.filterCascader(this.form.deptId);
                    this.loading=true;
                    let url = this.userAddUrl;
                    let data = {
                        studentId:this.form.studentId,
                        name:this.form.name,
                        cardNo:this.form.cardNo,
                        personType:1,
                        deptIdstr:deptId,
                        sex:this.form.sex,
                        identityCard:this.form.identityCard,
                        classNo:this.form.classNo,
                        studentType:this.form.studentType,
                        roomNumber:this.form.roomNumber,
                        postDescrible:this.form.postDescrible,
                        office:this.form.office,
                        expertise:this.form.expertise,
                        hobby:this.form.hobby,
                        graduationDate:this.form.graduationDate,
                        orderNum:this.form.orderNum,
                        mobile1:this.form.mobile1,
                    };
                    this.apiPost(url,data).then((res)=>{
                        this.loading=false;
                        if(res.status == 200){
                            this.$commonFn.showTip(res.message,1);
                            this.visible=false;
                            this.$parent.getData();
                        }else{
                            this.$commonFn.showTip(res.message,3);
                        }
                    },(err)=>{
                        console.log(err);
                        this.loading=false;
                    })
                 });
            }
        },
        mixins: [http]
    }
</script>

<style scoped>
</style>




// WEBPACK FOOTER //
// src/components/page/sys/student/Add.vue